document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('.grid-articles-button');
    const gridContainer = document.querySelector('.grid-articles-grid');
    let currentPage = 1;
    
    function createSkeletonLoader() {
        const skeleton = document.createElement('div');
        skeleton.className = 'grid-articles-grid-item skeleton-loader';
        skeleton.innerHTML = `
            <div class="grid-articles-grid-item-content">
                <div class="skeleton-image"></div>
                <div class="skeleton-categories">
                    <div class="skeleton-category"></div>
                    <div class="skeleton-category"></div>
                    <div class="skeleton-category"></div>
                </div>
                <div class="skeleton-title"></div>
                <div class="skeleton-title"></div>
            </div>
        `;
        return skeleton;
    }
    
    function removeSkeletonLoaders() {
        const skeletons = gridContainer.querySelectorAll('.skeleton-loader');
        skeletons.forEach(skeleton => skeleton.remove());
    }
    
    if (loadMoreButton && gridContainer) {
        loadMoreButton.addEventListener('click', async function() {
            loadMoreButton.disabled = true;
            loadMoreButton.textContent = 'Loading...';
            
            const skeletonCount = 3;
            for (let i = 0; i < skeletonCount; i++) {
                gridContainer.appendChild(createSkeletonLoader());
            }
            
            try {
                const response = await fetch(`json/posts.json?page=${currentPage}`);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch posts');
                }
                
                const data = await response.json();
                const posts = data.posts || [];
                
                removeSkeletonLoaders();
                
                posts.forEach(post => {
                    const gridItem = document.createElement('div');
                    gridItem.className = 'grid-articles-grid-item';
                    
                    const categoriesHTML = post.categories.map(category => 
                        `<a href="#">${category}</a>`
                    ).join('');
                    
                    gridItem.innerHTML = `
                        <div class="grid-articles-grid-item-content">
                            <picture>
                                <source media="(min-width: 768px)" srcset="${post.image}" type="image/webp">
                                <source srcset="${post.image}" type="image/webp">
                                <img src="${post.image}" alt="${post.title}" loading="lazy">
                            </picture>
                            <div class="categories">
                                ${categoriesHTML}
                            </div>
                            <a class="grid-articles-grid-item-title" href="#">${post.title}</a>
                        </div>
                    `;
                    
                    gridContainer.appendChild(gridItem);
                });
                
                console.log(`Loaded ${posts.length} posts for page ${currentPage}`);
                
                if (posts.length === 0) {
                    loadMoreButton.style.display = 'none';
                } else {
                    currentPage++;
                }
            } catch (error) {
                removeSkeletonLoaders();
                console.error('Error loading posts:', error);
            } finally {
                loadMoreButton.disabled = false;
                loadMoreButton.textContent = 'Load More';
            }
        });
    }
});

